import React, { Component, Suspense } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import Layout from './Containers/Layout/Layout';
import Loading from './Components/UI/Loading/Loading';
import './App.css';
import Adventure from './Containers/Adventure/Adventure';
import Practice from './Containers/Practice/Practice';
import Guard from './Containers/Guard/Guard';

const CharacterSelection = React.lazy(()=> {
  return import('./Components/Game/CharacterSelection')
});

const Gallery = React.lazy(()=> {
  return import('./Components/Gallery/Gallery')
});

class App extends Component {

  render() {
    let routes = (
      <Switch>
        <Route path="/adventures" component={Adventure} />
        <Route path="/games" render={()=> <CharacterSelection />} />
        <Route path="/gallery" render={()=> <Gallery  />} />
        <Route exact path="/practice" render={()=> <Practice  />} />
        <Route path="/practice/*" component={Practice}/>
        {/* <Route exact path="/practice/:sub?/:file?" component={Practice}/> */}


        {/* <Route
          exact
          path="/practice/:sub"
          render={() => {
              return (
                  <Redirect to="http://localhost:60702/practice/:sub" /> 
              )
          }}
        />        
        <Route exact path="/practice" render={()=> <Practice  />} /> */}
        <Route path='/testlogin' component={Guard} />
        <Route path="/" exact component={Layout} />
        <Redirect to="/" component={Layout} />
      </Switch>
    );    

    return (
        <div className="App">
          <Suspense fallback={<Loading />}>{routes}</Suspense>
        </div>
    );
  }
}

export default App;
